export const GenasysHomeUrl = 'https://genasys.com';
export const GenasysPrivacyPolicyUrl = 'https://genasys.com/privacy';
export const FaqUrl =
  'https://help.genasys.com/articles/zonehaven-aware-faqs';
